<template>
  <Teleport to="body">
  <template v-if="visivel">
  <div class="modal fade show d-block" tabindex="-1" @click.self="fechar">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable crm-modal-wide">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ campanha ? `Editar Campanha — ${campanha.nome}` : 'Nova Campanha' }}
            <small v-if="campanha" :class="['ms-2', statusBadge(campanha.status)]">{{ campanha.status }}</small>
          </h5>
          <button type="button" class="btn-close" @click="fechar"></button>
        </div>

        <div class="modal-body p-0">
          <BTabs nav-class="nav-tabs-custom border-bottom px-3 pt-2" content-class="p-3">
            <!-- ════════ Tab 1: Configuração ════════ -->
            <BTab active>
              <template #title><i class="ri-settings-3-line me-1"></i> Configuração</template>

              <BRow>
                <BCol md="6" class="mb-3">
                  <label class="form-label">Nome <span class="text-danger">*</span></label>
                  <input v-model="form.nome" type="text" class="form-control" :class="{ 'is-invalid': erros.nome }" />
                  <div v-if="erros.nome" class="invalid-feedback">{{ erros.nome }}</div>
                </BCol>
                <BCol md="6" class="mb-3">
                  <label class="form-label">Canal <span class="text-danger">*</span></label>
                  <Multiselect
                    v-model="form.canal"
                    :options="opcoesCanais"
                    label="label"
                    value-prop="value"
                    :can-clear="false"
                    :can-deselect="false"
                  />
                </BCol>
              </BRow>

              <div class="mb-3">
                <label class="form-label">Objetivo</label>
                <textarea v-model="form.objetivo" class="form-control" rows="2" placeholder="Ex: Convocação para o ato de 1º de maio"></textarea>
              </div>

              <!-- ── Tipo de disparo: WhatsApp e RCS têm vários; SMS escolhe o produto abaixo ── -->
              <BRow v-if="form.canal === 'whatsapp' || form.canal === 'rcs'">
                <BCol md="6" class="mb-3">
                  <label class="form-label">Tipo de disparo <span class="text-danger">*</span></label>
                  <Multiselect
                    v-model="form.provedor"
                    :options="opcoesProvedoresDoCanal"
                    label="label"
                    value-prop="value"
                    :can-clear="false"
                    :can-deselect="false"
                  />
                  <small class="text-muted d-block mt-1">{{ provedorDescricao }}</small>
                </BCol>
              </BRow>

              <!-- ── SMS: escolha do produto (cada um usa um pool de crédito) ── -->
              <BRow v-if="form.canal === 'sms'">
                <BCol md="6" class="mb-3">
                  <label class="form-label">Serviço SMS <span class="text-danger">*</span></label>
                  <Multiselect
                    v-model="form.provedor_config.cod_servico"
                    :options="opcoesServicosSms"
                    label="label"
                    value-prop="value"
                    :can-clear="false"
                    :can-deselect="false"
                  />
                  <small class="text-muted d-block mt-1">Cada produto SMS usa um pool de créditos próprio na Allcance.</small>
                </BCol>
              </BRow>

              <!-- ── Conteúdo Allcance ── -->
              <template v-if="ehAllcance">
                <div class="alert alert-info py-2 px-3 small d-flex align-items-start gap-2 mb-3">
                  <i class="ri-information-line mt-1"></i>
                  <div>
                    <template v-if="ehWhatsappAllcance">
                      Disparo em <strong>lote único</strong> pela Allcance: a <strong>mesma mensagem</strong> vai para todos,
                      sem personalização. Mínimo de <strong>{{ minimoNumeros.toLocaleString('pt-BR') }}</strong> números;
                      links/telefones no texto não ficam clicáveis; respostas não são coletadas.
                      <div v-if="contagem && contagem.publicoElegivel < minimoNumeros" class="mt-1 text-warning fw-semibold">
                        <i class="ri-alert-line me-1"></i>
                        Público elegível atual ({{ contagem.publicoElegivel }}) está abaixo do mínimo — a Allcance pode recusar.
                      </div>
                    </template>
                    <template v-else-if="ehRcs">
                      Disparo <strong>RCS</strong> via agente da Allcance, em lote. Mesma mensagem para todos.
                      Números sem RCS podem cair no <strong>fallback SMS</strong> (se ativado).
                    </template>
                    <template v-else>
                      Disparo de <strong>SMS</strong> em lote — a mesma mensagem vai para todos os números. Sem mínimo.
                    </template>
                  </div>
                </div>

                <!-- Saldo do serviço selecionado -->
                <div class="allc-saldo border rounded p-2 small mb-3 d-flex align-items-center justify-content-between">
                  <span>
                    <i class="ri-coin-line me-1 text-muted"></i>
                    <span class="text-muted">Saldo Allcance ({{ servicoLabelAtual }}):</span>
                    <template v-if="saldoAllcance && saldoAllcance.configurado">
                      <strong class="ms-1">{{ saldoProvedorAtual != null ? saldoProvedorAtual.toLocaleString('pt-BR') : '—' }}</strong>
                      <span class="text-muted"> créditos</span>
                    </template>
                    <span v-else-if="saldoAllcance" class="text-warning ms-1">credenciais não configuradas (Customização → Parâmetros)</span>
                    <span v-else class="text-muted ms-1">consultando…</span>
                  </span>
                  <BButton variant="ghost-secondary" size="sm" class="py-0 px-1" :disabled="saldoLoading" @click="_carregarSaldoAllcance">
                    <BSpinner v-if="saldoLoading" small /><i v-else class="ri-refresh-line"></i>
                  </BButton>
                </div>

                <div class="mb-3">
                  <label class="form-label">Título da campanha (Allcance)</label>
                  <input v-model="form.provedor_config.titulo" type="text" class="form-control" :placeholder="form.nome || 'Usa o nome da campanha'" />
                  <small class="text-muted">Identificação interna no painel Allcance. Se vazio, usa o nome da campanha.</small>
                </div>

                <!-- RCS: agente + fallback -->
                <BRow v-if="ehRcs">
                  <BCol md="6" class="mb-3">
                    <label class="form-label">Agente RCS <span class="text-danger">*</span></label>
                    <div class="d-flex gap-1">
                      <Multiselect
                        v-model="form.provedor_config.cod_agente_rcs"
                        :options="opcoesAgentesRcs"
                        label="label"
                        value-prop="value"
                        :searchable="true"
                        placeholder="Selecione o agente"
                        :class="{ 'is-invalid': erros.agente }"
                      />
                      <BButton variant="ghost-secondary" size="sm" :disabled="agentesRcsLoading" title="Recarregar agentes" @click="_carregarAgentesRcs">
                        <BSpinner v-if="agentesRcsLoading" small /><i v-else class="ri-refresh-line"></i>
                      </BButton>
                    </div>
                    <div v-if="erros.agente" class="invalid-feedback d-block">{{ erros.agente }}</div>
                    <small v-if="!opcoesAgentesRcs.length" class="text-muted">Nenhum agente RCS encontrado na conta Allcance.</small>
                  </BCol>
                  <BCol md="6" class="mb-3 d-flex align-items-end">
                    <div class="form-check form-switch">
                      <input id="rcsFallback" v-model="form.provedor_config.utilizar_fallback" class="form-check-input" type="checkbox" role="switch" />
                      <label for="rcsFallback" class="form-check-label">Fallback para SMS quando o número não tiver RCS</label>
                    </div>
                  </BCol>
                </BRow>

                <div class="mb-3">
                  <label class="form-label">Texto da mensagem <span class="text-danger">*</span></label>
                  <textarea
                    v-model="form.mensagem_texto"
                    class="form-control"
                    :maxlength="form.provedor === 'allcance_botao' ? 500 : null"
                    rows="4"
                    :class="{ 'is-invalid': erros.mensagem_texto }"
                    placeholder="Mensagem enviada, igual para todos os números."
                  ></textarea>
                  <div class="d-flex justify-content-between">
                    <div v-if="erros.mensagem_texto" class="invalid-feedback d-block">{{ erros.mensagem_texto }}</div>
                    <small v-if="form.provedor === 'allcance_botao'" class="ms-auto" :class="(form.mensagem_texto || '').length > 500 ? 'text-danger' : 'text-muted'">
                      {{ (form.mensagem_texto || '').length }}/500
                    </small>
                  </div>
                </div>

                <!-- RCS Simples: título da mensagem -->
                <div v-if="form.provedor === 'allcance_rcs_simples'" class="mb-3">
                  <label class="form-label">Título da mensagem (RCS)</label>
                  <input v-model="form.provedor_config.titulo_mensagem" type="text" class="form-control" placeholder="Título exibido no card RCS" />
                </div>

                <!-- Botão: WhatsApp com Botão ou RCS Simples -->
                <BRow v-if="temBotao">
                  <BCol md="5" class="mb-3">
                    <label class="form-label">Texto do botão <span v-if="form.provedor === 'allcance_botao'" class="text-danger">*</span></label>
                    <input v-model="form.provedor_config.botao.descricao" type="text" maxlength="25" class="form-control" :class="{ 'is-invalid': erros.botao }" placeholder="Ex: Saiba mais" />
                  </BCol>
                  <BCol md="7" class="mb-3">
                    <label class="form-label">Link de destino <span v-if="form.provedor === 'allcance_botao'" class="text-danger">*</span></label>
                    <input v-model="form.provedor_config.botao.link" type="url" class="form-control" :class="{ 'is-invalid': erros.botao }" placeholder="https://..." />
                    <div v-if="erros.botao" class="invalid-feedback d-block">{{ erros.botao }}</div>
                  </BCol>
                </BRow>

                <!-- Perfil: só WhatsApp em massa/botão -->
                <BRow v-if="ehWhatsappAllcance">
                  <BCol md="6" class="mb-3">
                    <label class="form-label">Nome de perfil (remetente)</label>
                    <input v-model="form.provedor_config.perfil_nome" type="text" class="form-control" placeholder="Ex: Atendimento" />
                    <small class="text-muted">Opcional. Nome exibido como remetente.</small>
                  </BCol>
                  <BCol md="6" class="mb-3">
                    <label class="form-label">Foto de perfil (remetente)</label>
                    <div class="d-flex align-items-center gap-2">
                      <img v-if="form.provedor_config.foto_perfil_base64" :src="form.provedor_config.foto_perfil_base64" class="allc-thumb rounded border" alt="foto de perfil" />
                      <input type="file" accept="image/*" class="form-control" @change="(e) => _lerImagem(e, 'foto_perfil_base64')" />
                      <BButton v-if="form.provedor_config.foto_perfil_base64" variant="ghost-danger" size="sm" title="Remover" @click="form.provedor_config.foto_perfil_base64 = ''"><i class="ri-close-line"></i></BButton>
                    </div>
                    <small class="text-muted">Opcional.</small>
                  </BCol>
                </BRow>

                <!-- Imagem: WhatsApp massivo ou RCS Simples -->
                <div v-if="temImagem" class="mb-3">
                  <label class="form-label">Imagem na mensagem</label>
                  <div class="d-flex align-items-center gap-2">
                    <img v-if="form.provedor_config.arquivo_base64" :src="form.provedor_config.arquivo_base64" class="allc-thumb rounded border" alt="imagem da mensagem" />
                    <input type="file" accept="image/*" class="form-control" @change="(e) => _lerImagem(e, 'arquivo_base64')" />
                    <BButton v-if="form.provedor_config.arquivo_base64" variant="ghost-danger" size="sm" title="Remover" @click="form.provedor_config.arquivo_base64 = ''"><i class="ri-close-line"></i></BButton>
                  </div>
                  <small class="text-muted">Opcional.</small>
                </div>
              </template>

              <!-- ── Conteúdo: rodízio de chips (API-B via QR code) ── -->
              <template v-if="ehBaileys">
                <div class="alert alert-info py-2 px-3 small d-flex align-items-start gap-2 mb-3">
                  <i class="ri-information-line mt-1"></i>
                  <div>
                    Envio <strong>1 a 1</strong> distribuído entre os chips marcados como <strong>Disparo</strong>
                    em Cadastros → Canais WhatsApp (QR). Cada chip espera um intervalo sorteado entre mensagens e para
                    no teto diário (Customização → Parâmetros → Campanhas). Números sem WhatsApp são descartados antes do envio. Respostas chegam no WhatsApp de cada chip
                    e registram o <strong>opt-in</strong> do contato (ou o opt-out, se ele pedir para sair).
                  </div>
                </div>

                <div class="border rounded p-2 small mb-3">
                  <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <span v-if="poolBaileys">
                      <i class="ri-sim-card-2-line me-1 text-muted"></i>
                      <strong>{{ poolBaileys.conectados }}</strong> de {{ poolBaileys.totalChips }} chip(s) conectado(s)
                      · <strong>{{ poolBaileys.disponiveis }}</strong> disponível(is) agora
                      · sem teto diário
                      · vazão ~<strong>{{ fmt(poolBaileys.vazaoPorHora) }}</strong>/h
                    </span>
                    <span v-else class="text-muted"><BSpinner v-if="poolLoading" small class="me-1" />Consultando chips…</span>
                    <BButton variant="ghost-secondary" size="sm" class="py-0 px-1" :disabled="poolLoading" title="Atualizar" @click="_carregarPoolBaileys">
                      <BSpinner v-if="poolLoading" small /><i v-else class="ri-refresh-line"></i>
                    </BButton>
                  </div>
                  <div v-if="poolBaileys && contagem && contagem.publicoElegivel && horasEstimadas != null" class="text-muted mt-1">
                    <i class="ri-time-line me-1"></i>
                    {{ fmt(contagem.publicoElegivel) }} elegível(is): ~{{ horasEstimadas }}h no ritmo atual. Conecte mais chips para terminar antes.
                  </div>
                  <div v-if="poolBaileys && !poolBaileys.conectados" class="text-danger mt-1">
                    <i class="ri-error-warning-line me-1"></i>Nenhum chip de disparo conectado — a campanha não inicia sem ao menos um.
                  </div>
                </div>

                <div class="mb-3">
                  <label class="form-label">Chips usados</label>
                  <Multiselect
                    v-model="form.provedor_config.canais_baileys_ids"
                    :options="opcoesChipsBaileys"
                    mode="tags"
                    :searchable="true"
                    placeholder="Todos os chips de disparo"
                  />
                  <small class="text-muted">Vazio = todos os chips marcados como Disparo (inclusive os conectados depois de iniciar).</small>
                </div>

                <div class="mb-3">
                  <label class="form-label">Imagem <small class="text-muted">(opcional — o texto vai como legenda)</small></label>
                  <div class="d-flex align-items-center gap-2 flex-wrap">
                    <a v-if="imagemBaileys" :href="urlAsset(imagemBaileys.url)" target="_blank" rel="noopener">
                      <img :src="urlAsset(imagemBaileys.url)" class="rod-thumb rounded border" alt="imagem da campanha" />
                    </a>
                    <input
                      ref="inputImagemBaileys"
                      type="file"
                      accept="image/png,image/jpeg,image/webp"
                      class="form-control rod-file"
                      :disabled="enviandoImagem"
                      @change="enviarImagemBaileys"
                    />
                    <BSpinner v-if="enviandoImagem" small />
                    <BButton v-if="imagemBaileys && !enviandoImagem" variant="ghost-danger" size="sm" title="Remover imagem" @click="removerImagemBaileys">
                      <i class="ri-close-line"></i>
                    </BButton>
                  </div>
                  <small v-if="imagemBaileys" class="text-muted d-block mt-1">
                    {{ imagemBaileys.nome }} · {{ Math.round((imagemBaileys.tamanho || 0) / 1024) }} KB (já reduzida para envio em massa)
                  </small>
                  <small v-else class="text-muted d-block mt-1">PNG, JPG ou WEBP. A imagem é reduzida no upload (cada envio sobe a imagem de novo).</small>
                  <div v-if="erros.imagem" class="invalid-feedback d-block">{{ erros.imagem }}</div>
                </div>

                <div class="mb-3">
                  <label class="form-label">
                    {{ imagemBaileys ? 'Legenda / texto' : 'Texto da mensagem' }}
                    <span v-if="!imagemBaileys" class="text-danger">*</span>
                  </label>
                  <textarea
                    v-model="form.mensagem_texto"
                    class="form-control"
                    rows="5"
                    :class="{ 'is-invalid': erros.mensagem_texto }"
                    placeholder="Olá {{nome}}, ..."
                  ></textarea>
                  <div v-if="erros.mensagem_texto" class="invalid-feedback d-block">{{ erros.mensagem_texto }}</div>
                  <small class="text-muted">
                    Variáveis: <code v-pre>{{nome}}</code>, <code v-pre>{{nome_completo}}</code>,
                    <code v-pre>{{cidade}}</code>, <code v-pre>{{bairro}}</code>. Links ganham prévia (card) automaticamente.
                  </small>
                </div>
              </template>

              <BRow v-if="form.canal === 'whatsapp' && form.provedor === 'meta_oficial'">
                <BCol md="6" class="mb-3">
                  <label class="form-label">Canal WhatsApp (BSP) <span class="text-danger">*</span></label>
                  <Multiselect
                    v-model="form.canal_whatsapp_id"
                    :options="opcoesCanaisWa"
                    label="label"
                    value-prop="value"
                    :searchable="true"
                    placeholder="Selecione o número que executa o disparo"
                    :class="{ 'is-invalid': erros.canal_whatsapp_id }"
                  />
                  <small v-if="canalWaEscolhido" class="text-muted d-block mt-1">
                    Limite diário: <strong>{{ canalWaEscolhido.tier_diario || '—' }}</strong> ·
                    Qualidade: <strong>{{ canalWaEscolhido.quality_rating || '—' }}</strong>
                  </small>
                  <small v-if="saldoCanalEscolhido && !saldoCanalEscolhido.ilimitado" class="d-block">
                    <i class="ri-battery-2-charge-line me-1"></i>
                    <span :class="saldoCanalEscolhido.saldo <= 0 ? 'text-danger fw-semibold' : (saldoCanalEscolhido.saldo <= Math.max(1, (saldoCanalEscolhido.limite || 0) * 0.1) ? 'text-warning fw-semibold' : 'text-success fw-semibold')">
                      {{ saldoCanalEscolhido.saldo }} envios restantes hoje
                    </span>
                    <span class="text-muted"> ({{ saldoCanalEscolhido.usado }}/{{ saldoCanalEscolhido.limite }} já usados neste número)</span>
                  </small>
                  <div v-if="erros.canal_whatsapp_id" class="invalid-feedback d-block">{{ erros.canal_whatsapp_id }}</div>
                </BCol>
                <BCol md="6" class="mb-3">
                  <label class="form-label">Template HSM <span class="text-danger">*</span></label>
                  <Multiselect
                    v-model="form.template_nome"
                    :options="opcoesTemplates"
                    label="label"
                    value-prop="value"
                    :searchable="true"
                    placeholder="Escolha um template aprovado"
                  />
                  <small v-if="templateEscolhido" class="text-muted d-block mt-1">{{ templateEscolhido.preview }}</small>
                </BCol>
              </BRow>

              <div v-if="form.canal === 'whatsapp' && form.provedor === 'meta_oficial' && templateEscolhido && (templateEscolhido.parametros || []).length" class="mb-3 border rounded p-3 bg-light-subtle">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <label class="form-label fw-semibold mb-0">
                    <i class="ri-braces-line me-1"></i>
                    Variáveis do template
                  </label>
                  <small class="text-muted">{{ (templateEscolhido.parametros || []).length }} variável(is) detectada(s)</small>
                </div>

                <div v-for="p in (templateEscolhido.parametros || [])" :key="p.nome" class="mb-3">
                  <div class="d-flex align-items-center gap-2 mb-1">
                    <span class="badge bg-primary-subtle text-primary">
                      <code>&#123;&#123;{{ p.indice || p.nome }}&#125;&#125;</code>
                    </span>
                    <small class="text-muted">{{ p.label || p.nome }}</small>
                  </div>
                  <BRow>
                    <BCol md="4">
                      <Multiselect
                        :model-value="varTipo(p.nome)"
                        :options="opcoesTipoVariavel"
                        label="label"
                        value-prop="value"
                        :can-clear="false"
                        :can-deselect="false"
                        @update:model-value="(val) => mudarVarTipo(p.nome, val)"
                      />
                    </BCol>
                    <BCol md="6">
                      <!-- Modo: Texto fixo -->
                      <input
                        v-if="varTipo(p.nome) === 'fixo'"
                        :value="varValorFixo(p.nome)"
                        type="text"
                        class="form-control"
                        placeholder="Texto literal — pode usar {{nome}}, {{cidade}}..."
                        @input="(e) => mudarVar(p.nome, { valor: e.target.value })"
                      />
                      <!-- Modo: Campo do contato -->
                      <Multiselect
                        v-else-if="varTipo(p.nome) === 'campo_contato'"
                        :model-value="varCampoContato(p.nome)"
                        :options="opcoesCamposContato"
                        label="label"
                        value-prop="value"
                        :searchable="true"
                        placeholder="Escolha o campo"
                        @update:model-value="(val) => mudarVar(p.nome, { campo: val })"
                      />
                      <!-- Modo: Campo personalizado -->
                      <Multiselect
                        v-else-if="varTipo(p.nome) === 'campo_personalizado'"
                        :model-value="varCampoPersonalizadoId(p.nome)"
                        :options="opcoesCamposPersonalizados"
                        label="label"
                        value-prop="value"
                        :searchable="true"
                        placeholder="Escolha o campo personalizado"
                        @update:model-value="(val) => mudarVar(p.nome, { campo_id: val })"
                      />
                    </BCol>
                    <BCol md="2">
                      <input
                        :value="varFallback(p.nome)"
                        type="text"
                        class="form-control"
                        placeholder="Fallback"
                        title="Valor usado quando o campo do contato vier vazio"
                        @input="(e) => mudarVar(p.nome, { fallback: e.target.value })"
                      />
                    </BCol>
                  </BRow>
                  <small v-if="varTipo(p.nome) === 'fixo'" class="text-muted d-block mt-1">
                    Placeholders disponíveis:
                    <code>&#123;&#123;nome&#125;&#125;</code>,
                    <code>&#123;&#123;sobrenome&#125;&#125;</code>,
                    <code>&#123;&#123;nome_completo&#125;&#125;</code>,
                    <code>&#123;&#123;cidade&#125;&#125;</code>,
                    <code>&#123;&#123;estado&#125;&#125;</code>,
                    <code>&#123;&#123;documento&#125;&#125;</code>,
                    <code>&#123;&#123;bairro&#125;&#125;</code>.
                  </small>
                </div>

                <div class="mt-2 p-2 border rounded bg-white">
                  <div class="text-muted small mb-1">
                    <i class="ri-eye-line me-1"></i>
                    Pré-visualização (com 1º contato da amostra):
                  </div>
                  <div class="font-monospace small" style="white-space: pre-wrap;">{{ previewTemplateRender }}</div>
                </div>
              </div>

              <div v-if="form.canal === 'whatsapp' && form.provedor === 'meta_oficial'" class="mb-3">
                <label class="form-label">Texto livre (alternativo, só p/ contatos dentro de janela 24h)</label>
                <textarea
                  v-model="form.mensagem_texto"
                  class="form-control"
                  rows="3"
                  placeholder="Use só se for relançar para quem já interagiu nas últimas 24h. Para reativação fria, use template HSM acima."
                ></textarea>
              </div>
            </BTab>

            <!-- ════════ Tab 2: Filtros ════════ -->
            <BTab>
              <template #title><i class="ri-filter-3-line me-1"></i> Filtros do Público</template>

              <BRow>
                <BCol md="6" class="mb-3">
                  <label class="form-label">Estados (UF)</label>
                  <Multiselect
                    v-model="form.filtros.estados"
                    :options="listaUFs"
                    mode="tags"
                    :searchable="true"
                    placeholder="Todas as UFs"
                  />
                </BCol>
                <BCol md="6" class="mb-3">
                  <label class="form-label">Cidades</label>
                  <Multiselect
                    v-model="form.filtros.cidades"
                    :options="opcoesCidades"
                    mode="tags"
                    :searchable="true"
                    :create-option="true"
                    placeholder="Todas as cidades"
                  />
                  <small class="text-muted">Aceita digitar e pressionar Enter para adicionar.</small>
                </BCol>
              </BRow>

              <BRow>
                <BCol md="6" class="mb-3">
                  <label class="form-label">Etiquetas — incluir <span class="text-danger">*</span></label>
                  <Multiselect
                    v-model="form.filtros.rotulosIncluir"
                    :options="opcoesRotulos"
                    mode="tags"
                    :searchable="true"
                    placeholder="Selecione etiquetas"
                    :class="{ 'is-invalid': erros.publico }"
                  />
                </BCol>
                <BCol md="6" class="mb-3">
                  <label class="form-label">Etiquetas — excluir</label>
                  <Multiselect
                    v-model="form.filtros.rotulosExcluir"
                    :options="opcoesRotulos"
                    mode="tags"
                    :searchable="true"
                    placeholder="Nenhuma"
                  />
                </BCol>
              </BRow>

              <BRow>
                <BCol md="12" class="mb-3">
                  <div class="d-flex justify-content-between align-items-center flex-wrap gap-1 mb-1">
                    <label class="form-label mb-0">
                      <i class="ri-group-2-line me-1"></i>
                      Incluir participantes de grupos de WhatsApp
                    </label>
                    <div class="hstack gap-1">
                      <BButton
                        variant="soft-primary"
                        size="sm"
                        :disabled="!opcoesGrupos.length || (form.filtros.gruposIncluir || []).length === opcoesGrupos.length"
                        @click="marcarTodosGrupos"
                      >
                        <i class="ri-checkbox-multiple-line me-1"></i>Marcar todos
                      </BButton>
                      <BButton
                        variant="soft-secondary"
                        size="sm"
                        :disabled="!(form.filtros.gruposIncluir || []).length"
                        @click="limparGrupos"
                      >
                        <i class="ri-close-line me-1"></i>Limpar
                      </BButton>
                    </div>
                  </div>
                  <Multiselect
                    v-model="form.filtros.gruposIncluir"
                    :options="opcoesGrupos"
                    mode="tags"
                    :searchable="true"
                    placeholder="Selecione um ou mais grupos"
                  />
                  <small class="text-muted d-block mt-1">
                    Os participantes <strong>com número conhecido</strong> entram na lista de disparo (quem esconde o número/@lid não é alcançável). Contatos novos são criados automaticamente ao iniciar.
                  </small>
                  <div v-if="(form.filtros.gruposIncluir || []).length && form.filtros.exigirConsentimento"
                    class="alert alert-warning py-2 px-3 mt-2 mb-0 small">
                    <i class="ri-alert-line me-1"></i>
                    Com <strong>“Exigir opt-in”</strong> ligado, participantes sem opt-in registrado <strong>não</strong> receberão.
                  </div>
                </BCol>
              </BRow>

              <BRow>
                <BCol md="4" class="mb-3">
                  <label class="form-label">Status do contato</label>
                  <Multiselect
                    v-model="form.filtros.statusContato"
                    :options="[
                      { value: 'ativo',     label: 'Ativo' },
                      { value: 'inativo',   label: 'Inativo' },
                      { value: 'bloqueado', label: 'Bloqueado' },
                    ]"
                    label="label"
                    value-prop="value"
                    :can-clear="false"
                    :can-deselect="false"
                  />
                </BCol>
                <BCol md="8" class="mb-3 d-flex align-items-end">
                  <div class="form-check form-switch">
                    <input
                      id="exigirConsent"
                      v-model="form.filtros.exigirConsentimento"
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                    />
                    <label for="exigirConsent" class="form-check-label">
                      Exigir opt-in válido (LGPD)
                      <small class="d-block text-muted">Desligado: envia com ou sem opt-in — quem responder vira opt-in. Quem pediu para sair (SAIR/PARAR) nunca recebe.</small>
                    </label>
                  </div>
                </BCol>
              </BRow>

              <div class="border rounded p-2 mb-3 bg-light-subtle">
                <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <div class="small">
                    <i class="ri-group-line me-1 text-primary"></i>
                    <span v-if="contagemLoading" class="text-muted">
                      <BSpinner small class="me-1" /> Calculando público...
                    </span>
                    <span v-else-if="contagem">
                      <strong class="fs-5 text-primary">{{ contagem.publicoElegivel }}</strong>
                      <span class="text-muted">elegíveis</span>
                      ·
                      <span class="text-muted">{{ contagem.publicoEstimado }} estimado(s)</span>
                      ·
                      <template v-if="form.filtros.exigirConsentimento || contagem.bloqueadosSemConsentimento">
                        <span class="text-warning">
                          {{ contagem.bloqueadosSemConsentimento }} {{ form.filtros.exigirConsentimento ? 'sem opt-in' : 'com opt-out' }}
                        </span>
                        ·
                      </template>
                      <span class="text-danger">{{ contagem.semTelefone }} sem telefone</span>
                      <span v-if="contagem.grupos && contagem.grupos.distintos" class="d-block mt-1 text-info">
                        <i class="ri-group-2-line me-1"></i>
                        Grupos: <strong>{{ contagem.grupos.distintos }}</strong> com número
                        ({{ contagem.grupos.jaContatos }} já são contato · {{ contagem.grupos.novos }} novos<template v-if="contagem.grupos.sobrepostos"> · {{ contagem.grupos.sobrepostos }} já no público, não contados 2×</template>)
                      </span>
                    </span>
                    <span v-else class="text-muted">Ajuste filtros para ver a contagem.</span>
                  </div>
                  <BButton variant="soft-info" size="sm" @click="gerarPreview" :disabled="previewLoading">
                    <BSpinner v-if="previewLoading" small class="me-1" />
                    <i v-else class="ri-search-line me-1"></i>
                    Mostrar amostra
                  </BButton>
                </div>
              </div>

              <div v-if="preview && preview.amostra && preview.amostra.length" class="border rounded">
                <div class="px-3 py-2 border-bottom small text-muted">
                  Amostra dos primeiros {{ preview.amostra.length }} elegíveis:
                </div>
                <div class="table-responsive" style="max-height: 220px;">
                  <table class="table table-sm table-borderless mb-0">
                    <thead><tr><th>Nome</th><th>Cidade/UF</th><th>Telefone</th></tr></thead>
                    <tbody>
                      <tr v-for="c in preview.amostra" :key="c.id">
                        <td>{{ c.nome }} {{ c.sobrenome || '' }}</td>
                        <td><small class="text-muted">{{ c.cidade || '—' }} / {{ c.estado || '—' }}</small></td>
                        <td><code>{{ c.telefone_exibicao || c.telefone || '—' }}</code></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </BTab>

            <!-- ════════ Tab 3: Fila e Agendamento ════════ -->
            <BTab>
              <template #title><i class="ri-calendar-schedule-line me-1"></i> Fila & Agendamento</template>

              <BRow>
                <BCol md="6" class="mb-3">
                  <label class="form-label">Início programado</label>
                  <AppDatepicker v-model="form.inicio_programado" mode="datetime" placeholder="dd/mm/aaaa hh:mm" />
                </BCol>
                <BCol md="6" class="mb-3">
                  <label class="form-label">Fim programado</label>
                  <AppDatepicker v-model="form.fim_programado" mode="datetime" placeholder="dd/mm/aaaa hh:mm" />
                </BCol>
              </BRow>

              <BRow>
                <BCol md="3" class="mb-3">
                  <label class="form-label">Janela diária — início</label>
                  <input v-model="form.janela_inicio" type="time" class="form-control" />
                </BCol>
                <BCol md="3" class="mb-3">
                  <label class="form-label">Janela diária — fim</label>
                  <input v-model="form.janela_fim" type="time" class="form-control" />
                  <small class="text-muted">Padrão de segurança 08:00–21:00. Para 24h, use 00:00–23:59.</small>
                </BCol>
                <BCol md="6" class="mb-3">
                  <label class="form-label">Dias permitidos</label>
                  <div class="d-flex gap-1 flex-wrap pt-1">
                    <BButton
                      v-for="d in diasSemana"
                      :key="d.value"
                      :variant="form.dias_semana && form.dias_semana.includes(d.value) ? 'primary' : 'soft-secondary'"
                      size="sm"
                      @click="alternarDia(d.value)"
                    >{{ d.label }}</BButton>
                  </div>
                  <small class="text-muted">Vazio = qualquer dia.</small>
                </BCol>
              </BRow>

              <div v-if="ehBaileys" class="alert alert-secondary py-2 px-3 small mb-3">
                <i class="ri-timer-line me-1"></i>
                No rodízio de chips o ritmo é por chip e vale para todas as campanhas: intervalo, teto diário e pausa
                ficam em Customização → Parâmetros → Campanhas (e o teto também pode ser ajustado chip a chip).
              </div>
              <BRow>
                <BCol v-if="!ehBaileys" md="4" class="mb-3">
                  <label class="form-label">Intervalo entre disparos (s)</label>
                  <input v-model.number="form.intervalo_segundos" type="number" min="0" max="600" class="form-control" />
                  <small class="text-muted">
                    Vale por linha de envio. Com os envios simultâneos definidos em
                    Customização → Parâmetros, a vazão é simultâneos ÷ intervalo por segundo.
                    Recomendado: 3–10s para preservar reputação do número.
                  </small>
                </BCol>
                <BCol v-if="!ehBaileys" md="4" class="mb-3">
                  <label class="form-label">Limite diário (override)</label>
                  <input
                    v-model.number="form.limite_diario_override"
                    type="number"
                    min="1"
                    class="form-control"
                    :placeholder="`Tier do canal: ${canalWaEscolhido?.tier_diario || '—'}`"
                  />
                  <small class="text-muted">Se vazio, usa o tier do canal Meta.</small>
                </BCol>
                <BCol md="4" class="mb-3">
                  <label class="form-label">Tentativas em falha</label>
                  <input v-model.number="form.max_tentativas" type="number" min="1" max="10" class="form-control" />
                </BCol>
              </BRow>
            </BTab>

            <!-- ════════ Tab 4: Progresso (apenas se em execução) ════════ -->
            <BTab v-if="campanha && ['em_execucao', 'pausada', 'concluida', 'cancelada'].includes(campanha.status)">
              <template #title><i class="ri-line-chart-line me-1"></i> Progresso</template>

              <div v-if="loadingProgresso" class="text-center py-4"><BSpinner /></div>
              <template v-else-if="progresso">
                <div v-if="progresso.provedor && String(progresso.provedor).startsWith('allcance')" class="alert alert-secondary py-2 px-3 small mb-3">
                  <div><i class="ri-send-plane-2-line me-1"></i><strong>Disparo Allcance</strong> ({{ labelProvedor(progresso.provedor) }})</div>
                  <div v-if="progresso.provedor_referencia" class="text-muted">Referência: <code>{{ progresso.provedor_referencia }}</code></div>
                  <div v-if="progresso.provedor_status" class="text-muted">Status Allcance: {{ progresso.provedor_status }}</div>
                  <div class="text-muted mt-1"><i class="ri-time-line me-1"></i>A entrega é confirmada por consulta periódica à Allcance (pode levar alguns minutos).</div>
                </div>
                <BRow class="mb-3">
                  <BCol sm="3"><div class="border rounded p-2 text-center"><div class="small text-muted">Destinatários</div><h4 class="mb-0">{{ progresso.total_destinatarios || 0 }}</h4></div></BCol>
                  <BCol sm="3"><div class="border rounded p-2 text-center"><div class="small text-muted">Processados</div><h4 class="mb-0">{{ progresso.total_processados || 0 }}</h4></div></BCol>
                  <BCol sm="3"><div class="border rounded p-2 text-center"><div class="small text-muted">Enviados</div><h4 class="mb-0 text-success">{{ progresso.total_enviados || 0 }}</h4></div></BCol>
                  <BCol sm="3"><div class="border rounded p-2 text-center"><div class="small text-muted">Falhas</div><h4 class="mb-0 text-danger">{{ progresso.total_falhas || 0 }}</h4></div></BCol>
                </BRow>
                <BRow class="mb-3">
                  <BCol sm="3"><div class="border rounded p-2 text-center"><div class="small text-muted">Entregues</div><h4 class="mb-0 text-info">{{ progresso.total_entregues || 0 }}</h4></div></BCol>
                  <BCol sm="3"><div class="border rounded p-2 text-center"><div class="small text-muted">Lidos</div><h4 class="mb-0 text-primary">{{ progresso.total_lidos || 0 }}</h4></div></BCol>
                  <BCol v-if="progresso.baileys" sm="3"><div class="border rounded p-2 text-center"><div class="small text-muted">Enviados hoje (chips)</div><h4 class="mb-0">{{ fmt(progresso.baileys.enviadosHoje) }}</h4><div class="small text-muted">sem teto diário</div></div></BCol>
                  <BCol v-else sm="3"><div class="border rounded p-2 text-center"><div class="small text-muted">Restante hoje (número)</div><h4 class="mb-0">{{ progresso.restanteHoje ?? '∞' }}</h4><div v-if="progresso.limiteHoje" class="small text-muted">{{ progresso.usadoHoje || 0 }}/{{ progresso.limiteHoje }} usados</div></div></BCol>
                  <BCol sm="3"><div class="border rounded p-2 text-center"><div class="small text-muted">Pendentes</div><h4 class="mb-0">{{ (progresso.detalheFila || {}).pendente || 0 }}</h4></div></BCol>
                </BRow>

                <div class="mb-2">
                  <div class="progress" style="height: 14px;">
                    <div
                      class="progress-bar bg-success"
                      :style="`width: ${pctEnviado}%`"
                    >{{ pctEnviado }}%</div>
                    <div
                      class="progress-bar bg-danger"
                      :style="`width: ${pctFalha}%`"
                    >{{ pctFalha }}%</div>
                  </div>
                </div>

                <div class="d-flex gap-2 mt-3 flex-wrap">
                  <span v-for="(qtd, k) in (progresso.detalheFila || {})" :key="k" class="badge bg-light text-dark">
                    {{ k }}: {{ qtd }}
                  </span>
                </div>

                <div class="d-flex align-items-center gap-2 mt-3 flex-wrap">
                  <span class="small text-muted"><i class="ri-file-chart-line me-1"></i>Relatório de disparo:</span>
                  <BButton variant="soft-danger" size="sm" :disabled="!!gerandoRelatorio" @click="relatorioDisparo('pdf')">
                    <BSpinner v-if="gerandoRelatorio === 'pdf'" small class="me-1" /><i v-else class="ri-file-pdf-2-line me-1"></i>PDF (resumo)
                  </BButton>
                  <BButton variant="soft-success" size="sm" :disabled="!!gerandoRelatorio" @click="relatorioDisparo('csv')">
                    <BSpinner v-if="gerandoRelatorio === 'csv'" small class="me-1" /><i v-else class="ri-file-excel-2-line me-1"></i>CSV (todos os destinatários)
                  </BButton>
                </div>

                <!-- Rodízio de chips: situação de cada chip -->
                <div v-if="progresso.baileys" class="mt-3">
                  <div class="small mb-2">
                    <i class="ri-sim-card-2-line me-1 text-muted"></i>
                    <strong>{{ progresso.baileys.disponiveis }}</strong> chip(s) enviando agora de {{ progresso.baileys.totalChips }}
                    · {{ progresso.baileys.pausados }} pausado(s)
                    · vazão ~{{ fmt(progresso.baileys.vazaoPorHora) }}/h
                    <template v-if="progresso.baileys.horasParaTerminar != null"> · ~{{ progresso.baileys.horasParaTerminar }}h para terminar</template>
                  </div>
                  <div class="table-responsive border rounded chips-tabela">
                    <table class="table table-sm align-middle mb-0 small">
                      <thead>
                        <tr><th>Chip</th><th>Status</th><th class="text-end">Hoje</th><th>Observação</th><th></th></tr>
                      </thead>
                      <tbody>
                        <tr v-for="c in progresso.baileys.chips" :key="c.id">
                          <td>{{ c.nome }}<div class="text-muted">{{ c.telefone || '—' }}</div></td>
                          <td><span :class="badgeChip(c)">{{ rotuloChip(c) }}</span></td>
                          <td class="text-end text-nowrap">{{ c.enviadosHoje }}<div v-if="c.falhasHoje" class="text-danger">{{ c.falhasHoje }} falha(s)</div></td>
                          <td class="text-muted chips-obs">{{ c.pausado ? `Pausado até ${hora(c.pausadoAte)} — ${c.ultimoErro || ''}` : '' }}</td>
                          <td class="text-end">
                            <BButton v-if="c.pausado" variant="soft-primary" size="sm" class="py-0" @click="retomarChip(c.id)">Retomar</BButton>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </template>
            </BTab>
          </BTabs>
        </div>

        <div class="modal-footer">
          <div class="me-auto small text-muted" v-if="mensagem">
            <span :class="mensagem.tipo === 'erro' ? 'text-danger' : 'text-success'">
              <i :class="mensagem.tipo === 'erro' ? 'ri-error-warning-line' : 'ri-check-line'"></i>
              {{ mensagem.texto }}
            </span>
          </div>
          <BButton variant="ghost-dark" @click="fechar">Fechar</BButton>
          <BButton type="button" variant="success" :disabled="salvando" @click="salvar">
            <BSpinner v-if="salvando" small class="me-1" />
            {{ salvando ? 'Salvando...' : (campanha ? 'Salvar alterações' : 'Salvar campanha') }}
          </BButton>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" @click="fechar"></div>
  </template>
  </Teleport>
</template>

<script>
import { api, sucesso } from '@/helpers/common/api';
import socketClient from '@/services/socketClient';
import { baixarRelatorioDisparo } from '@/helpers/campanhaRelatorioDisparo';
import axios from 'axios';
import resolveUrl from '@/services/resolveUrl';

const ESTADO_FILTROS_DEFAULT = () => ({
  estados: [],
  cidades: [],
  rotulosIncluir: [],
  rotulosExcluir: [],
  gruposIncluir: [],
  statusContato: 'ativo',
  // Opt-in desligado por padrão; o usuário liga no switch se quiser.
  exigirConsentimento: false,
});

// Config dos disparos Allcance. `texto` reutiliza form.mensagem_texto.
const PROVEDOR_CONFIG_DEFAULT = () => ({
  titulo: '',
  perfil_nome: '',
  foto_perfil_base64: '',
  arquivo_base64: '',
  botao: { descricao: '', link: '' },
  cod_servico: '4',                 // SMS: produto padrão (SMS Massivo)
  cod_agente_rcs: null,             // RCS: agente escolhido
  utilizar_fallback: true,          // RCS: fallback p/ SMS
  utilizar_msg_principal_fallback: true,
  titulo_mensagem: '',              // RCS Simples: título do card
  canais_baileys_ids: [],           // Rodízio de chips: vazio = todos os chips de disparo
  imagem: null,                     // Rodízio de chips: { url, mimetype, nome, tamanho }
});

// Volumes mínimos exigidos pela Allcance por tipo (só WhatsApp massa/botão).
const MINIMO_ALLCANCE = { allcance_massivo: 2000, allcance_botao: 10000 };

// Produtos SMS (cod_servico) e o nome do serviço no /creditos (p/ saldo).
const SERVICOS_SMS = [
  { value: '2', label: 'SMS OTP', saldo: 'SMS OTP' },
  { value: '4', label: 'SMS Massivo', saldo: 'SMS MASSIVO' },
  { value: '11', label: 'SMS Transacional', saldo: 'SMS TRANSACIONAL' },
  { value: '14', label: 'SMS Blend', saldo: 'SMS BLEND' },
  { value: '15', label: 'SMS Bet Compartilhada', saldo: 'SMS BET COMPARTILHADA' },
  { value: '16', label: 'SMS Bet Direta', saldo: 'SMS BET DIRETA' },
];
// Nome do serviço no /creditos por provedor WhatsApp.
const SALDO_NOME = { allcance_massivo: 'WHATSAPP', allcance_botao: 'WHATSAPP BOTAO' };
const normNome = (s) => String(s || '').toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();

export default {
  name: 'CampanhaModal',
  props: {
    visivel: { type: Boolean, default: false },
    campanha: { type: Object, default: null },
  },
  emits: ['fechar', 'salvo'],
  data() {
    return {
      form: this._formVazio(),
      erros: {},
      salvando: false,
      mensagem: null,

      opcoesCanais: [
        { value: 'whatsapp', label: 'WhatsApp' },
        { value: 'sms',      label: 'SMS' },
        { value: 'rcs',      label: 'RCS' },
        { value: 'ligacao',  label: 'Ligação' },
        { value: 'email',    label: 'E-mail' },
      ],
      // provedores por canal. SMS não entra aqui (produto escolhido à parte).
      opcoesProvedores: [
        { value: 'meta_oficial', canal: 'whatsapp', label: 'WhatsApp Oficial (Meta)', descricao: 'Template HSM personalizado, envio 1 a 1 e limite diário do número Meta.' },
        { value: 'allcance_massivo', canal: 'whatsapp', label: 'Disparo via WhatsApp (Allcance)', descricao: 'Envio em massa — mesma mensagem para todos, via Allcance. Mínimo 2.000 números.' },
        { value: 'allcance_botao', canal: 'whatsapp', label: 'WhatsApp com Botão (Allcance)', descricao: 'Massa com 1 botão de link. Texto até 500 caracteres. Mínimo 10.000 números.' },
        { value: 'baileys_rodizio', canal: 'whatsapp', label: 'Rodízio de chips (WhatsApp via QR code)', descricao: 'Texto personalizado enviado 1 a 1, distribuído entre os chips conectados por QR code.' },
        { value: 'allcance_rcs_basico', canal: 'rcs', label: 'RCS Básico (Allcance)', descricao: 'RCS de texto via agente. Fallback para SMS opcional.' },
        { value: 'allcance_rcs_simples', canal: 'rcs', label: 'RCS Simples (Allcance)', descricao: 'RCS com título, botão de link e imagem, via agente.' },
      ],
      saldoAllcance: null,
      saldoLoading: false,
      poolBaileys: null,
      poolLoading: false,
      gerandoRelatorio: null, // 'pdf' | 'csv' enquanto o arquivo é montado
      enviandoImagem: false,
      agentesRcs: [],
      agentesRcsLoading: false,
      canaisWa: [],
      usoCanais: {},           // canal_id -> { limite, usado, saldo, ilimitado }
      templates: [],
      rotulos: [],
      grupos: [],
      cidadesTop: [],
      camposPersonalizados: [],

      preview: null,
      previewLoading: false,

      contagem: null,
      contagemLoading: false,
      contagemTimer: null,
      contagemSeq: 0,

      opcoesTipoVariavel: [
        { value: 'fixo', label: 'Texto fixo' },
        { value: 'campo_contato', label: 'Campo do contato' },
        { value: 'campo_personalizado', label: 'Campo personalizado' },
      ],
      opcoesCamposContato: [
        { value: 'nome', label: 'Nome' },
        { value: 'sobrenome', label: 'Sobrenome' },
        { value: 'nome_completo', label: 'Nome completo' },
        { value: 'cidade', label: 'Cidade' },
        { value: 'estado', label: 'Estado (UF)' },
        { value: 'bairro', label: 'Bairro' },
        { value: 'documento', label: 'Documento' },
        { value: 'cep', label: 'CEP' },
        { value: 'logradouro', label: 'Logradouro' },
      ],

      progresso: null,
      loadingProgresso: false,
      pollTimer: null,
      socketOff: null,

      listaUFs: [
        'AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT',
        'PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO',
      ],
      diasSemana: [
        { value: 0, label: 'Dom' }, { value: 1, label: 'Seg' }, { value: 2, label: 'Ter' },
        { value: 3, label: 'Qua' }, { value: 4, label: 'Qui' }, { value: 5, label: 'Sex' }, { value: 6, label: 'Sáb' },
      ],
    };
  },
  computed: {
    opcoesCanaisWa() {
      return (this.canaisWa || [])
        .filter((c) => c.status === 'ativo')
        .map((c) => ({ value: c.id, label: `${c.telefone_formatado || c.display_name || ''} (tier ${c.tier_diario || '—'})` }));
    },
    canalWaEscolhido() {
      return (this.canaisWa || []).find((c) => c.id === this.form.canal_whatsapp_id) || null;
    },
    saldoCanalEscolhido() {
      return this.usoCanais[this.form.canal_whatsapp_id] || null;
    },
    ehAllcance() {
      return String(this.form.provedor || '').startsWith('allcance');
    },
    ehBaileys() {
      return this.form.provedor === 'baileys_rodizio';
    },
    imagemBaileys() {
      const img = this.form.provedor_config && this.form.provedor_config.imagem;
      return img && img.url ? img : null;
    },
    opcoesChipsBaileys() {
      return ((this.poolBaileys && this.poolBaileys.chips) || []).map((c) => ({
        value: c.id,
        label: `${c.nome}${c.telefone ? ` (${c.telefone})` : ''}${c.conectado ? '' : ' — desconectado'}`,
      }));
    },
    /** Horas para enviar ao público elegível na vazão atual do pool. */
    horasEstimadas() {
      const p = this.poolBaileys;
      const publico = (this.contagem && this.contagem.publicoElegivel) || 0;
      if (!p || !publico || !p.vazaoPorHora) return null;
      return Math.round((publico / p.vazaoPorHora) * 10) / 10;
    },
    ehWhatsappAllcance() {
      return this.form.provedor === 'allcance_massivo' || this.form.provedor === 'allcance_botao';
    },
    ehRcs() {
      return this.form.provedor === 'allcance_rcs_basico' || this.form.provedor === 'allcance_rcs_simples';
    },
    temBotao() {
      return this.form.provedor === 'allcance_botao' || this.form.provedor === 'allcance_rcs_simples';
    },
    temImagem() {
      return this.form.provedor === 'allcance_massivo' || this.form.provedor === 'allcance_rcs_simples';
    },
    opcoesProvedoresDoCanal() {
      return this.opcoesProvedores.filter((p) => p.canal === this.form.canal);
    },
    opcoesServicosSms() {
      return SERVICOS_SMS.map((s) => ({ value: s.value, label: s.label }));
    },
    opcoesAgentesRcs() {
      return (this.agentesRcs || []).map((a) => ({
        value: a.id ?? a.cod ?? a.codigo ?? a.cod_agente ?? a.agente_id,
        label: a.nome || a.name || a.descricao || `Agente ${a.id ?? a.cod ?? ''}`,
      })).filter((o) => o.value != null);
    },
    provedorAtual() {
      return this.opcoesProvedores.find((p) => p.value === this.form.provedor) || null;
    },
    provedorDescricao() {
      return this.provedorAtual ? this.provedorAtual.descricao : '';
    },
    servicoLabelAtual() {
      if (this.form.provedor === 'allcance_sms') {
        const s = SERVICOS_SMS.find((x) => x.value === this.form.provedor_config.cod_servico);
        return s ? s.label : 'SMS';
      }
      return this.provedorAtual ? this.provedorAtual.label : '';
    },
    minimoNumeros() {
      return MINIMO_ALLCANCE[this.form.provedor] || 0;
    },
    saldoProvedorAtual() {
      const mapa = (this.saldoAllcance && this.saldoAllcance.mapa) || null;
      if (!mapa) return null;
      if (this.form.provedor === 'allcance_sms') {
        const s = SERVICOS_SMS.find((x) => x.value === this.form.provedor_config.cod_servico);
        return s ? (mapa[normNome(s.saldo)] ?? null) : null;
      }
      if (this.ehRcs) {
        const k = Object.keys(mapa).find((key) => key.includes('RCS'));
        return k ? mapa[k] : null;
      }
      const nome = SALDO_NOME[this.form.provedor];
      return nome ? (mapa[normNome(nome)] ?? null) : null;
    },
    opcoesTemplates() {
      return (this.templates || []).map((t) => ({ value: t.name, label: `${t.name}${t.padrao_inicial ? ' (padrão)' : ''}` }));
    },
    templateEscolhido() {
      return (this.templates || []).find((t) => t.name === this.form.template_nome) || null;
    },
    opcoesRotulos() {
      return (this.rotulos || []).map((r) => ({ value: r.id, label: r.nome }));
    },
    opcoesGrupos() {
      return (this.grupos || [])
        .filter((g) => !g.arquivado)
        .map((g) => ({
          value: g.id,
          label: `${g.nome || 'Grupo sem nome'}${g.participantes_count ? ` (${g.participantes_count})` : ''}`,
        }));
    },
    opcoesCidades() {
      return (this.cidadesTop || []).map((c) => c.cidade).filter(Boolean);
    },
    pctEnviado() {
      const p = this.progresso;
      if (!p || !p.total_destinatarios) return 0;
      return Math.round((Number(p.total_enviados || 0) / p.total_destinatarios) * 100);
    },
    pctFalha() {
      const p = this.progresso;
      if (!p || !p.total_destinatarios) return 0;
      return Math.round((Number(p.total_falhas || 0) / p.total_destinatarios) * 100);
    },
    opcoesCamposPersonalizados() {
      return (this.camposPersonalizados || []).map((c) => ({
        value: c.id,
        label: c.label || c.codigo || c.nome || `#${c.id}`,
      }));
    },
    /**
     * Renderiza preview do template substituindo cada parâmetro com base na
     * 1ª linha da amostra do preview (se disponível) ou em valores genéricos.
     */
    previewTemplateRender() {
      if (!this.templateEscolhido) return '';
      const base = this.templateEscolhido.preview || '';
      const amostra = (this.preview && this.preview.amostra && this.preview.amostra[0]) || {
        nome: 'Maria',
        sobrenome: 'Silva',
        cidade: 'Belo Horizonte',
        estado: 'MG',
      };
      const valores = {};
      for (const p of (this.templateEscolhido.parametros || [])) {
        valores[p.nome] = this._renderVariavel(p.nome, amostra);
      }
      let texto = base;
      for (const p of (this.templateEscolhido.parametros || [])) {
        const idxRegex = new RegExp(`\\{\\{\\s*${p.indice}\\s*\\}\\}`, 'g');
        texto = texto.replace(idxRegex, valores[p.nome] != null ? String(valores[p.nome]) : '');
      }
      return texto;
    },
  },
  watch: {
    visivel: {
      immediate: true,
      handler(val) {
        if (val) this._carregar();
        else this._desmontar();
      },
    },
    campanha: {
      handler(val) {
        if (val) this._popularDe(val);
        else this.form = this._formVazio();
        this.erros = {};
        this.mensagem = null;
        this.preview = null;
        this.contagem = null;
      },
    },
    'form.filtros': {
      deep: true,
      handler() { this._scheduleContagem(); },
    },
    'form.canal': {
      handler(canal) {
        this._scheduleContagem();
        // Ajusta o provedor ao trocar de canal (mantém consistência canal↔provedor).
        if (canal === 'sms') {
          this.form.provedor = 'allcance_sms';
          if (!this.form.provedor_config.cod_servico) this.form.provedor_config.cod_servico = '4';
        } else {
          const validos = this.opcoesProvedores.filter((p) => p.canal === canal).map((p) => p.value);
          if (validos.length && !validos.includes(this.form.provedor)) this.form.provedor = validos[0];
          else if (!validos.length && this.form.provedor !== 'meta_oficial') this.form.provedor = 'meta_oficial';
        }
      },
    },
    'form.provedor': {
      handler(val) {
        if (val === 'baileys_rodizio') {
          if (!this.form.provedor_config || typeof this.form.provedor_config !== 'object') {
            this.form.provedor_config = PROVEDOR_CONFIG_DEFAULT();
          }
          if (!Array.isArray(this.form.provedor_config.canais_baileys_ids)) this.form.provedor_config.canais_baileys_ids = [];
          if (!this.poolBaileys) this._carregarPoolBaileys();
        }
        if (String(val).startsWith('allcance')) {
          if (!this.form.provedor_config || typeof this.form.provedor_config !== 'object') {
            this.form.provedor_config = PROVEDOR_CONFIG_DEFAULT();
          }
          if (!this.form.provedor_config.botao) this.form.provedor_config.botao = { descricao: '', link: '' };
          if (!this.saldoAllcance) this._carregarSaldoAllcance();
          if ((val === 'allcance_rcs_basico' || val === 'allcance_rcs_simples') && !this.agentesRcs.length) {
            this._carregarAgentesRcs();
          }
        }
      },
    },
    // Quando o usuário troca de template, garante que os parâmetros
    // existam como objetos {tipo, valor, ...} prontos pra UI
    'form.template_nome': {
      handler() { this._inicializarVariaveis(); },
    },
    // Troca de canal → recarrega os templates DESSE canal (cada canal tem seu
    // próprio conjunto sincronizado da Meta).
    'form.canal_whatsapp_id': {
      handler() { this._carregarTemplates(); },
    },
  },
  beforeUnmount() {
    this._desmontar();
  },
  methods: {
    _formVazio() {
      return {
        nome: '',
        objetivo: '',
        canal: 'whatsapp',
        provedor: 'meta_oficial',
        provedor_config: PROVEDOR_CONFIG_DEFAULT(),
        canal_whatsapp_id: null,
        template_nome: null,
        template_idioma: 'pt_BR',
        template_parametros: {},
        mensagem_texto: '',
        inicio_programado: '',
        fim_programado: '',
        intervalo_segundos: 5,
        limite_diario_override: null,
        // Janela de segurança padrão (evita disparo de madrugada). Dentro dela
        // dispara na hora. Para 24h: use 00:00–23:59. Dias vazio = qualquer dia.
        janela_inicio: '08:00',
        janela_fim: '21:00',
        dias_semana: [],
        max_tentativas: 3,
        filtros: ESTADO_FILTROS_DEFAULT(),
      };
    },
    _popularDe(c) {
      const filtrosBase = ESTADO_FILTROS_DEFAULT();
      const filtros = (c.filtros && typeof c.filtros === 'object') ? { ...filtrosBase, ...c.filtros } : filtrosBase;

      // Backwards-compat: se não tem filtros mas tem segmentos legacy, popula rotulosIncluir/Excluir
      if (!c.filtros && Array.isArray(c.segmentos)) {
        for (const s of c.segmentos) {
          const id = s.rotulo_id || (s.rotulo && s.rotulo.id);
          if (!id) continue;
          if (s.operador === 'excluir') filtros.rotulosExcluir.push(id);
          else filtros.rotulosIncluir.push(id);
        }
      }

      const cfgBase = PROVEDOR_CONFIG_DEFAULT();
      const cfgSalvo = (c.provedor_config && typeof c.provedor_config === 'object') ? c.provedor_config : {};

      this.form = {
        nome: c.nome || '',
        objetivo: c.objetivo || '',
        canal: c.canal || 'whatsapp',
        provedor: c.provedor || 'meta_oficial',
        provedor_config: { ...cfgBase, ...cfgSalvo, botao: { ...cfgBase.botao, ...(cfgSalvo.botao || {}) } },
        canal_whatsapp_id: c.canal_whatsapp_id || null,
        template_nome: c.template_nome || null,
        template_idioma: c.template_idioma || 'pt_BR',
        template_parametros: c.template_parametros || {},
        mensagem_texto: c.mensagem_texto || '',
        inicio_programado: c.inicio_programado || '',
        fim_programado: c.fim_programado || '',
        intervalo_segundos: c.intervalo_segundos ?? 5,
        limite_diario_override: c.limite_diario_override || null,
        janela_inicio: c.janela_inicio || '08:00',
        janela_fim: c.janela_fim || '21:00',
        dias_semana: Array.isArray(c.dias_semana) ? c.dias_semana : [],
        max_tentativas: c.max_tentativas ?? 3,
        filtros,
      };
    },
    async _carregarTemplates() {
      // Mesma fonte do worker de disparo: templates sincronizados da Meta por
      // canal. Passa o canal selecionado; sem ele, o backend usa o canal ativo.
      const canalId = this.form.canal_whatsapp_id;
      const url = canalId ? `/campanha/templates?canalWhatsappId=${canalId}` : '/campanha/templates';
      const r = await api.read(url);
      this.templates = Array.isArray(r) ? r : [];
    },
    async _carregarSaldoAllcance() {
      this.saldoLoading = true;
      try {
        const r = await api.read('/campanha/saldoAllcance');
        this.saldoAllcance = r || { configurado: false, mapa: {} };
      } catch (_e) {
        this.saldoAllcance = { configurado: false, mapa: {} };
      } finally {
        this.saldoLoading = false;
      }
    },
    async _carregarPoolBaileys() {
      this.poolLoading = true;
      try {
        this.poolBaileys = await api.read('/canal/baileys/poolDisparo');
      } catch (_e) {
        this.poolBaileys = null;
      } finally {
        this.poolLoading = false;
      }
    },
    urlAsset(url) {
      if (!url || /^(https?:|data:)/i.test(url)) return url || '';
      const base = resolveUrl(process.env.VUE_APP_APIURL) || '';
      return `${base.replace(/\/$/, '')}${url}`;
    },
    async enviarImagemBaileys(evento) {
      const file = evento && evento.target && evento.target.files && evento.target.files[0];
      if (!file) return;
      if (file.size > 10 * 1024 * 1024) {
        this.erros = { ...this.erros, imagem: 'Imagem muito grande (máx. 10 MB).' };
        evento.target.value = '';
        return;
      }
      this.enviandoImagem = true;
      this.erros = { ...this.erros, imagem: null };
      try {
        const fd = new FormData();
        fd.append('file', file);
        const { data } = await axios.post('/campanha/imagemDisparo', fd, { timeout: 0 });
        this.form.provedor_config = { ...this.form.provedor_config, imagem: data };
      } catch (e) {
        const resp = e && e.response && e.response.data;
        this.erros = { ...this.erros, imagem: (resp && (resp.details || resp.error)) || 'Falha ao enviar a imagem.' };
      } finally {
        this.enviandoImagem = false;
        if (this.$refs.inputImagemBaileys) this.$refs.inputImagemBaileys.value = '';
      }
    },
    removerImagemBaileys() {
      this.form.provedor_config = { ...this.form.provedor_config, imagem: null };
    },
    async relatorioDisparo(formato) {
      if (!this.campanha || this.gerandoRelatorio) return;
      this.gerandoRelatorio = formato;
      try {
        await baixarRelatorioDisparo(this.campanha.id, formato);
      } finally {
        this.gerandoRelatorio = null;
      }
    },
    async retomarChip(id) {
      await api.create(`/canal/baileys/retomarDisparo/${id}`, {});
      this._carregarProgresso(false);
    },
    fmt(n) {
      return Number(n || 0).toLocaleString('pt-BR');
    },
    hora(d) {
      return d ? new Date(d).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : '';
    },
    rotuloChip(c) {
      if (c.pausado) return 'Pausado';
      if (!c.conectado) return c.status === 'banido' ? 'Banido' : 'Desconectado';
      return 'Enviando';
    },
    badgeChip(c) {
      if (c.pausado) return 'badge bg-warning-subtle text-warning';
      if (!c.conectado) return 'badge bg-danger-subtle text-danger';
      return 'badge bg-success-subtle text-success';
    },
    labelProvedor(p) {
      const map = {
        baileys_rodizio: 'Rodízio de chips',
        allcance_massivo: 'WhatsApp massivo',
        allcance_botao: 'WhatsApp com botão',
        allcance_sms: 'SMS',
        allcance_rcs_basico: 'RCS Básico',
        allcance_rcs_simples: 'RCS Simples',
      };
      return map[p] || p;
    },
    async _carregarAgentesRcs() {
      this.agentesRcsLoading = true;
      try {
        const r = await api.read('/campanha/agentesRcs');
        this.agentesRcs = (r && Array.isArray(r.agentes)) ? r.agentes : [];
      } catch (_e) {
        this.agentesRcs = [];
      } finally {
        this.agentesRcsLoading = false;
      }
    },
    /** Lê um arquivo de imagem como data URL base64 e grava em provedor_config[campo]. */
    _lerImagem(evento, campo) {
      const file = evento && evento.target && evento.target.files && evento.target.files[0];
      if (!file) return;
      const MAX = 2 * 1024 * 1024; // 2MB — cabe na coluna JSON e evita payload gigante
      if (file.size > MAX) {
        this.mensagem = { tipo: 'erro', texto: 'Imagem muito grande (máx. 2MB).' };
        evento.target.value = '';
        return;
      }
      const reader = new FileReader();
      reader.onload = () => { this.form.provedor_config[campo] = String(reader.result || ''); };
      reader.readAsDataURL(file);
    },
    async _carregar() {
      const tasks = [
        api.read('/canal/whatsapp').then((r) => { this.canaisWa = Array.isArray(r) ? r : []; }),
        api.read('/canal/whatsapp/uso').then((r) => {
          const m = {};
          (Array.isArray(r) ? r : []).forEach((u) => { m[u.id] = u; });
          this.usoCanais = m;
        }),
        this._carregarTemplates(),
        api.read('/rotulo?limit=999').then((r) => { this.rotulos = Array.isArray(r) ? r : (r?.data || []); }),
        api.read('/grupo?limit=999').then((r) => { this.grupos = Array.isArray(r) ? r : (r?.data || []); }),
        api.read('/contato/total').then((r) => { this.cidadesTop = (r && r.topCidades) || []; }),
        api.read('/campopersonalizado?ativo=true').then((r) => { this.camposPersonalizados = Array.isArray(r) ? r : (r?.data || []); }),
      ];
      await Promise.allSettled(tasks);

      if (this.campanha) {
        // A LISTA não traz provedor_config (base64 pesado) — busca a campanha
        // completa por id para popular título/botão/imagens da Allcance.
        let completa = this.campanha;
        try {
          const r = await api.read(`/campanha/${this.campanha.id}`);
          if (r && r.id) completa = r;
        } catch (_e) { /* usa o que veio da lista */ }
        this._popularDe(completa);
        this._iniciarMonitoramento();
      } else {
        this.form = this._formVazio();
      }
      this._inicializarVariaveis();
      // Dispara contagem inicial pra mostrar quantos contatos batem com filtros default
      this._scheduleContagem();
      if (this.ehAllcance) this._carregarSaldoAllcance();
      if (this.ehRcs) this._carregarAgentesRcs();
      if (this.ehBaileys) this._carregarPoolBaileys();
    },
    _desmontar() {
      if (this.pollTimer) { clearInterval(this.pollTimer); this.pollTimer = null; }
      if (this.socketOff) { this.socketOff(); this.socketOff = null; }
      if (this.contagemTimer) { clearTimeout(this.contagemTimer); this.contagemTimer = null; }
    },

    /**
     * Agenda contagem ao vivo do público (debounced 600ms). Usa um sequenciador
     * pra descartar respostas atrasadas se o usuário mudou de filtros entre
     * requisições.
     */
    _scheduleContagem() {
      if (this.contagemTimer) clearTimeout(this.contagemTimer);
      this.contagemTimer = setTimeout(() => this._executarContagem(), 600);
    },
    async _executarContagem() {
      this.contagemSeq += 1;
      const seq = this.contagemSeq;
      this.contagemLoading = true;
      try {
        const r = await api.create('/campanha/preview', {
          canal: this.form.canal,
          filtros: this.form.filtros,
          apenasContagem: true,
        });
        if (seq !== this.contagemSeq) return; // resposta obsoleta
        this.contagem = r || { publicoEstimado: 0, publicoElegivel: 0, bloqueadosSemConsentimento: 0, semTelefone: 0 };
      } finally {
        if (seq === this.contagemSeq) this.contagemLoading = false;
      }
    },

    /**
     * Garante que cada parâmetro do template tenha um objeto
     * {tipo, valor?, campo?, campo_id?, fallback?} no form.template_parametros.
     * Mantém compatibilidade com strings legadas.
     */
    _inicializarVariaveis() {
      const tpl = this.templateEscolhido;
      if (!tpl) return;
      const novo = { ...(this.form.template_parametros || {}) };
      for (const p of (tpl.parametros || [])) {
        const atual = novo[p.nome];
        if (typeof atual === 'string') {
          novo[p.nome] = { tipo: 'fixo', valor: atual, fallback: '' };
        } else if (!atual || typeof atual !== 'object') {
          // Default inteligente: se nome do param bate com campo do contato, sugere
          const sugestao = ['nome', 'sobrenome', 'cidade', 'estado'].find((c) => c === p.nome);
          if (sugestao) novo[p.nome] = { tipo: 'campo_contato', campo: sugestao, fallback: '' };
          else novo[p.nome] = { tipo: 'fixo', valor: '', fallback: '' };
        }
      }
      this.form.template_parametros = novo;
    },

    /** Helpers para a UI de variáveis (cada acessor garante objeto). */
    _ensureVar(nome) {
      const params = this.form.template_parametros || {};
      if (!params[nome] || typeof params[nome] !== 'object') {
        params[nome] = { tipo: 'fixo', valor: typeof params[nome] === 'string' ? params[nome] : '', fallback: '' };
        this.form.template_parametros = { ...params };
      }
      return this.form.template_parametros[nome];
    },
    varTipo(nome) { return this._ensureVar(nome).tipo || 'fixo'; },
    varValorFixo(nome) { return this._ensureVar(nome).valor || ''; },
    varCampoContato(nome) { return this._ensureVar(nome).campo || null; },
    varCampoPersonalizadoId(nome) { return this._ensureVar(nome).campo_id || null; },
    varFallback(nome) { return this._ensureVar(nome).fallback || ''; },
    mudarVarTipo(nome, tipo) {
      const v = this._ensureVar(nome);
      const novo = { ...v, tipo };
      // Limpa campos não pertinentes ao novo tipo
      if (tipo === 'fixo') { delete novo.campo; delete novo.campo_id; }
      if (tipo === 'campo_contato') { delete novo.valor; delete novo.campo_id; }
      if (tipo === 'campo_personalizado') { delete novo.valor; delete novo.campo; }
      this.form.template_parametros = { ...this.form.template_parametros, [nome]: novo };
    },
    mudarVar(nome, patch) {
      const v = this._ensureVar(nome);
      this.form.template_parametros = { ...this.form.template_parametros, [nome]: { ...v, ...patch } };
    },
    /** Renderiza uma variável usando uma amostra de contato (preview UI). */
    _renderVariavel(nome, contato) {
      const v = this._ensureVar(nome);
      const fallback = v.fallback || '';
      if (v.tipo === 'fixo') {
        const texto = (v.valor || '');
        return texto
          .replace(/\{\{\s*nome\s*\}\}/gi, contato.nome || '')
          .replace(/\{\{\s*sobrenome\s*\}\}/gi, contato.sobrenome || '')
          .replace(/\{\{\s*nome_completo\s*\}\}/gi, [contato.nome, contato.sobrenome].filter(Boolean).join(' '))
          .replace(/\{\{\s*cidade\s*\}\}/gi, contato.cidade || '')
          .replace(/\{\{\s*estado\s*\}\}/gi, contato.estado || '')
          || fallback;
      }
      if (v.tipo === 'campo_contato') {
        if (v.campo === 'nome_completo') return [contato.nome, contato.sobrenome].filter(Boolean).join(' ') || fallback;
        return (contato[v.campo] || fallback);
      }
      if (v.tipo === 'campo_personalizado') {
        return fallback || '[campo personalizado]';
      }
      return fallback;
    },
    _iniciarMonitoramento() {
      if (!this.campanha) return;
      this._desmontar();
      this._carregarProgresso();

      try {
        const off = socketClient.on('campanha:progresso', ({ campanha_id, progresso }) => {
          if (Number(campanha_id) !== Number(this.campanha.id)) return;
          this.progresso = { ...(this.progresso || {}), detalheFila: progresso };
          this._carregarProgresso(false);
        });
        const off2 = socketClient.on('campanha:concluida', ({ campanha_id }) => {
          if (Number(campanha_id) === Number(this.campanha.id)) this._carregarProgresso();
        });
        this.socketOff = () => { off && off(); off2 && off2(); };
      } catch (_e) { /* socket pode não estar disponível */ }

      this.pollTimer = setInterval(() => this._carregarProgresso(false), 8000);
    },
    async _carregarProgresso(comLoading = true) {
      if (!this.campanha) return;
      if (comLoading) this.loadingProgresso = true;
      try {
        const r = await api.read(`/campanha/progresso/${this.campanha.id}`);
        if (r) this.progresso = r;
      } finally {
        if (comLoading) this.loadingProgresso = false;
      }
    },
    marcarTodosGrupos() {
      this.form.filtros.gruposIncluir = this.opcoesGrupos.map((g) => g.value);
    },
    limparGrupos() {
      this.form.filtros.gruposIncluir = [];
    },
    alternarDia(d) {
      const arr = Array.isArray(this.form.dias_semana) ? [...this.form.dias_semana] : [];
      const idx = arr.indexOf(d);
      if (idx >= 0) arr.splice(idx, 1); else arr.push(d);
      arr.sort((a, b) => a - b);
      this.form.dias_semana = arr;
    },
    statusBadge(status) {
      const map = {
        rascunho: 'badge bg-secondary-subtle text-secondary',
        validando: 'badge bg-info-subtle text-info',
        pronta: 'badge bg-primary-subtle text-primary',
        em_execucao: 'badge bg-warning-subtle text-warning',
        pausada: 'badge bg-dark-subtle text-dark',
        concluida: 'badge bg-success-subtle text-success',
        cancelada: 'badge bg-danger-subtle text-danger',
      };
      return map[status] || 'badge bg-secondary-subtle text-secondary';
    },
    async gerarPreview() {
      this.previewLoading = true;
      try {
        const r = await api.create('/campanha/preview', {
          canal: this.form.canal,
          filtros: this.form.filtros,
          limit: 30,
        });
        this.preview = r || { publicoEstimado: 0, publicoElegivel: 0, bloqueadosSemConsentimento: 0, semTelefone: 0, amostra: [] };
      } finally {
        this.previewLoading = false;
      }
    },
    validar() {
      this.erros = {};
      if (!this.form.nome || !this.form.nome.trim()) this.erros.nome = 'Nome é obrigatório.';
      if (!this.form.canal) this.erros.canal = 'Canal é obrigatório.';
      if (this.form.canal === 'whatsapp' && this.form.provedor === 'meta_oficial' && !this.form.canal_whatsapp_id) {
        this.erros.canal_whatsapp_id = 'Escolha o número WhatsApp BSP.';
      }
      if (this.ehBaileys && !(this.form.mensagem_texto || '').trim() && !this.imagemBaileys) {
        this.erros.mensagem_texto = 'Informe o texto e/ou envie uma imagem.';
      }
      if (this.ehAllcance) {
        const texto = (this.form.mensagem_texto || '').trim();
        if (!texto) this.erros.mensagem_texto = 'Informe o texto da mensagem.';
        if (this.form.provedor === 'allcance_botao') {
          if (texto.length > 500) this.erros.mensagem_texto = 'Máximo de 500 caracteres para o WhatsApp com Botão.';
          const b = (this.form.provedor_config && this.form.provedor_config.botao) || {};
          if (!String(b.descricao || '').trim() || !String(b.link || '').trim()) {
            this.erros.botao = 'Informe o texto do botão e o link de destino.';
          }
        }
        if (this.ehRcs && !this.form.provedor_config.cod_agente_rcs) {
          this.erros.agente = 'Selecione o agente RCS.';
        }
      }
      const temPublico = (this.form.filtros.rotulosIncluir && this.form.filtros.rotulosIncluir.length)
        || (this.form.filtros.cidades && this.form.filtros.cidades.length)
        || (this.form.filtros.estados && this.form.filtros.estados.length)
        || (this.form.filtros.gruposIncluir && this.form.filtros.gruposIncluir.length);
      if (!temPublico) this.erros.publico = 'Defina ao menos uma etiqueta, cidade, UF ou grupo.';
      return Object.keys(this.erros).length === 0;
    },
    _payload() {
      const f = this.form;
      const payload = {
        nome: f.nome,
        objetivo: f.objetivo || null,
        canal: f.canal,
        provedor: f.provedor || 'meta_oficial',
        provedor_config: this._provedorConfigPayload(),
        canal_whatsapp_id: f.canal_whatsapp_id || null,
        template_nome: f.template_nome || null,
        template_idioma: f.template_idioma || 'pt_BR',
        template_parametros: f.template_parametros || {},
        mensagem_texto: f.mensagem_texto || null,
        filtros: f.filtros,
        intervalo_segundos: f.intervalo_segundos ?? 5,
        limite_diario_override: f.limite_diario_override || null,
        janela_inicio: f.janela_inicio || null,
        janela_fim: f.janela_fim || null,
        dias_semana: Array.isArray(f.dias_semana) && f.dias_semana.length ? f.dias_semana : null,
        max_tentativas: f.max_tentativas ?? 3,
        inicio_programado: f.inicio_programado || null,
        fim_programado: f.fim_programado || null,
      };
      return payload;
    },
    _provedorConfigPayload() {
      const cfg = this.form.provedor_config || {};
      if (this.ehAllcance) return cfg;
      if (this.ehBaileys) {
        return {
          canais_baileys_ids: Array.isArray(cfg.canais_baileys_ids) ? cfg.canais_baileys_ids : [],
          imagem: cfg.imagem && cfg.imagem.url ? cfg.imagem : null,
        };
      }
      return null;
    },
    async salvar() {
      if (!this.validar()) {
        this.mensagem = { tipo: 'erro', texto: 'Verifique os campos destacados nas abas.' };
        return;
      }
      this.salvando = true;
      this.mensagem = null;
      try {
        let result;
        if (this.campanha) {
          result = await api.update(`/campanha/${this.campanha.id}`, this._payload());
        } else {
          result = await api.create('/campanha', this._payload());
        }
        if (result) {
          sucesso();
          this.$emit('salvo', result);
          this.$emit('fechar');
        } else {
          this.mensagem = { tipo: 'erro', texto: 'Erro ao salvar. Verifique os dados informados.' };
        }
      } finally {
        this.salvando = false;
      }
    },
    fechar() {
      this.$emit('fechar');
    },
  },
};
</script>

<style scoped>
.modal { z-index: 1055; }
.modal-backdrop { z-index: 1040; cursor: pointer; }
.crm-modal-wide { max-width: min(1200px, calc(100vw - 1rem)); }
.allc-thumb { width: 40px; height: 40px; object-fit: cover; flex: 0 0 auto; }
.chips-tabela { max-height: 320px; overflow-y: auto; }
.rod-thumb { width: 64px; height: 64px; object-fit: cover; flex: 0 0 auto; }
.rod-file { max-width: 360px; }
.chips-tabela thead th { position: sticky; top: 0; background: var(--vz-secondary-bg, var(--vz-body-bg)); z-index: 1; }
.chips-obs { max-width: 260px; white-space: normal; }
</style>
